import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, CheckCircle2Icon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="pt-5 pb-4 px-4 relative" data-id="element-77">
      <div className="text-center relative z-10" data-id="element-78">
        <div className="inline-block bg-brand-swiss-red/10 text-brand-swiss-red text-[11px] sm:text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full mb-3" data-id="element-79">
          🇨🇭 Das Komplettsystem für technische Ausbildung
        </div>

        <motion.h1 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-[28px] leading-[1.1] sm:text-4xl md:text-5xl font-black text-brand-charcoal mb-3" data-id="element-80">
          Ihr komplettes Automationsjahr.
          <br data-id="element-81" />
          <span className="text-brand-swiss-red" data-id="element-82">Fertig. Jetzt.</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="text-[15px] sm:text-base text-gray-600 mb-4 leading-snug max-w-lg mx-auto" data-id="element-83">
          6 vollständige Fachmodule + 4 professionelle Toolkits.
          Praxisorientiert nach Industrie 4.0 Standard. Entwickelt für Schweizer
          Lehrpersonen, Instruktoren und Berufsbildner.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.15
      }} className="mb-4" data-id="element-84">
          <a href="#pricing" onClick={e => {
          e.preventDefault();
          document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="block cursor-pointer hover:opacity-95 transition-opacity" data-id="element-85">
            <img src="https://cdn.magicpatterns.com/uploads/gbPytGLhCDgdVJzS2cVD6p/my-project-page-1_(7).png" alt="System Automation & SPS PRO - Das Komplettsystem für industrielle Ausbildung" className="w-full h-auto object-contain drop-shadow-2xl" data-id="element-86" />
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.2
      }} className="flex flex-col items-center justify-center gap-1 mb-4" data-id="element-87">
          <div className="flex items-center gap-1 text-brand-gold" data-id="element-88">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-current" data-id="element-89" />)}
          </div>
          <span className="text-[13px] sm:text-sm font-bold text-brand-charcoal" data-id="element-90">
            +500 Instruktoren & Lehrpersonen | 100% Industrie 4.0 Ready | 🇨🇭
          </span>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.25
      }} className="grid grid-cols-2 gap-x-3 gap-y-2 text-[13px] sm:text-sm font-medium text-gray-700 mb-5 text-left max-w-md mx-auto" data-id="element-91">
          <div className="flex items-center gap-1.5" data-id="element-92">
            <CheckCircle2Icon className="w-4 h-4 sm:w-5 sm:h-5 text-brand-green-cta shrink-0" data-id="element-93" />
            <span data-id="element-94">100% Industrie 4.0</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-95">
            <CheckCircle2Icon className="w-4 h-4 sm:w-5 sm:h-5 text-brand-green-cta shrink-0" data-id="element-96" />
            <span data-id="element-97">Standard CH 2026</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-98">
            <CheckCircle2Icon className="w-4 h-4 sm:w-5 sm:h-5 text-brand-green-cta shrink-0" data-id="element-99" />
            <span data-id="element-100">Sofort-Download (PDF)</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-101">
            <CheckCircle2Icon className="w-4 h-4 sm:w-5 sm:h-5 text-brand-green-cta shrink-0" data-id="element-102" />
            <span data-id="element-103">Einmalige Zahlung</span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} data-id="element-104">
          <CTAButton className="w-full sm:w-auto sm:min-w-[300px]" data-id="element-105">
            ↓ JETZT ENTDECKEN ↓
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}